module.exports = __webpack_public_path__ + "static/img/examinedetailTCT.bb069f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/examinedetailTCT.png
// module id = ydia
// module chunks = 7